<template>
    <div id="bible-component">
        <div class="selection">
            <a class='dropdown-trigger btn' href='javascript:;' data-target='bookSelection'>
                <template v-if="selected.book.name">{{selected.book.name}}</template>
                <template v-else>Select Book</template>
            </a>

            <a v-show="selected.book.name" class='dropdown-trigger btn' href='javascript:;' data-target='chapterSelection' id="chapterSelectionBtn">
                <template v-if="selected.chapter">{{selected.chapter}}</template>
                <template v-else>Select Chapter</template>
            </a>

            <a class='dropdown-trigger btn' href='javascript:;' data-target='versionSelection'>
                <template>{{selected.version}}</template>
            </a>

            <a class='btn' href='javascript:;' v-on:click="clear()">
                X
            </a>

            <a class='btn' href='javascript:;' v-on:click="showHistory = !showHistory" :class="['historyBtn', showHistory ? 'active' : '']">
                <i class="material-icons">history</i>
            </a>

            <ul id='bookSelection' class='dropdown-content' style="width: 400px">
                <!-- <li v-for="(book, key) in books" :key="key" v-on:click="bookSelected(book)">{{book.abbreviation}}</li> -->
                
                <li class="testament">Old Testament</li>
                <li :class="[selected.book.name == book.name ? 'active' : '']" v-for="(book, key) in oldTestament" :key="'ot-' + key" v-on:click="bookSelected(book)">
                    {{book.abbreviation}}
                </li>
                <li class="testament">New Testament</li>
                <li :class="[selected.book.name == book.name ? 'active' : '']" v-for="(book, key) in newTestament" :key="'nt-' + key" v-on:click="bookSelected(book)">
                    {{book.abbreviation}}
                </li>
            </ul>

            <ul id='chapterSelection' class='dropdown-content'>
                <li :class="[selected.chapter == chapter ? 'active' : '']" v-for="(chapter, key) in selected.book.chapters" :key="key" v-on:click="chapterSelected(chapter)">{{chapter}}</li>
            </ul>
            
            <ul id='versionSelection' class='dropdown-content'>
                <li :class="[selected.version == version ? 'active' : '']" v-for="(version, key) in versions" :key="key" v-on:click="versionSelected(version)">{{version}}</li>
            </ul>

            <!-- <ul class="pagination">
                <li v-for="(chapter, key) in selected.book.chapters" :key="key" v-on:click="chapterSelected(chapter)">{{chapter}}</li>
            </ul> -->
        </div>
        <div class="verses-div" v-show="!showHistory">
            <ul class="collection">
                <li :class="['collection-item avatar', focusedVerse == key ? 'focused' : '']" v-for="(verse, key) in selected.verses" :key="key" v-on:click="verseSelected(key)">
                    <span class="circle">{{key +1}}</span>{{verse.text}}
                </li>
            </ul>
        </div>

        <div class="verses-history-div" v-show="showHistory">
            <ul class="collection">
                <li :class="['collection-item']" v-for="(verse, key) in history" :key="key" v-on:click="loadFromHistory(verse)">
                    {{verse.book.name}} {{verse.chapter}}:{{verse.verse + 1}}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>

//import io from 'socket.io-client';
import BibleService from '../services/Bible.js';
import M from 'materialize-css';
// import func from 'vue-editor-bridge';

export default {
    name: "Live",
    props: ['bibleContent'],
    data: function() {
        return {   
            id: this.$route.params.presentationid,
            liveContent: {
                type: "custom",
                content: {}
            },
            books: [],
            focusedVerse: "",
            selected: {
                book: {},
                chapter: null,
                verses: [],
                version: "nkjv"
            },
            history: [],
            showHistory: false,
            versions: ["nkjv", "niv"]
        }
    },
    mounted: function() {
        var elems = document.querySelectorAll('.dropdown-trigger');
        M.Dropdown.init(elems, {
            coverTrigger: false,
            constrainWidth: false,
            alignment: 'left'
        });
    },
    components: { },
    computed: {
        oldTestament: function () {
            return Object.assign([], this.books).splice(0,39);
        },
        newTestament: function () {
            return Object.assign([], this.books).splice(39,65);
        }
    },
    created: function() {
        const self = this;
        BibleService.getBooks().then(function(response) {    
            self.books = response.data;        
        })
        
        /*
        const presentationIdParam = this.$route.params.presentationid;
        this.socket.emit('joined room', presentationIdParam);

        this.socket.on('connected', (content) => {
            console.log("connected", this.socket);
            if (content) {
                let contentType = content.type.trim();
                if (contentType == "intro" || contentType == "title" || contentType == "lyrics") {
                    // let tempContent = {
                    //     type: "song",
                    //     content: content
                    // }
                    // this.liveContent = tempContent;
                }
                else if (contentType == "custom" || contentType == "verse" || contentType == "image" || contentType == "video") {
                    //let tempContent = {
                    //     type: "custom",
                    //     content: content
                    // }
                    // this.liveContent = tempContent;
                }
                else {
                    //this.liveContent = content;
                }
            }
        });

        this.socket.on('content update', (content) => {
            console.log("update", this.socket);
            // if (content != "") {
            //     this.liveContent = content;
            // }
            // else {
            //     this.liveContent = { type: "custom", content: {} };
            // }
        });

        this.socket.on('disconnect', (reason) => {
            this.socket.connect();
            console.log("reason", reason);
        });

        this.socket.on('error', (error) => {
            console.log("error", error)
        });

        this.socket.on('reconnecting', (attemptNumber) => {
            console.log("reconnecting", attemptNumber)
        });

        this.socket.on('reconnect_error', (error) => {
            console.log("reconnect error", error)
        });

        this.socket.on('reconnect', (attemptNumber) => {
            console.log("reconnected", attemptNumber)
            this.socket.emit('joined room', presentationIdParam);
        });
        */
    },
    methods: {
        bookSelected: function(pBook, pChapter, pVerse) {
            this.focusedVerse = "";
            this.selected.verses = [];
            this.selected.book = pBook;
            // this.selected.chapter = 1;
            let chapter = pChapter ? pChapter : 1;
            this.chapterSelected(chapter, pVerse);
            
            this.showHistory = false;
            // if (!pChapter) {
            //     document.getElementById("chapterSelectionBtn").click();
            // }
        },
        chapterSelected: function(pChapter, pVerse) {
            this.showHistory = false;
            this.focusedVerse = "";
            this.selected.chapter = pChapter;
            const self = this;

            BibleService.getChapter(this.selected).then(function(response) {    
                self.selected.verses = response.book.chapters.verses;

                if (pVerse) {
                    self.verseSelected(pVerse);
                }
            })
        },
        versionSelected: function(pVersion) {
            this.showHistory = false;
            this.selected.version = pVersion;
            
            if (this.selected.book && this.selected.chapter) {
                this.chapterSelected(this.selected.chapter);
            }
        },
        verseSelected: function(pKey) {
            this.focusedVerse = pKey;
            let tempVerse = {
                "type": "custom",
                "content": {
                    "type": "verse",
                    "content": {
                        "main": "<p>" + this.selected.verses[pKey].text + "</p>",
                        "sub": this.selected.verses[pKey].reference
                    }
                }
            }

            this.addToHistory(pKey);
            
            if (this.id != "main") {
                this.$emit('bibleContent', tempVerse)
            }
        },  
        addToHistory: function(pVerse) {
            let tempVerse = {
                book: this.selected.book,
                chapter: this.selected.chapter,
                verse: pVerse,
                version: this.selected.version
            }
            this.history.unshift(tempVerse);
        },
        loadFromHistory: function(pHistory) {
            this.bookSelected(pHistory.book, pHistory.chapter, pHistory.verse);
            this.versionSelected(pHistory.version);
        },
        clear: function() {
            this.focusedVerse = "";
            this.selected = {
                book: {},
                chapter: null,
                verses: [],
                version: "nkjv"
            }
            this.showHistory = false;
        }
    }
};
</script>

<style scoped>

    #bible {
        width: 100%;
        height: 100vh;
        padding: 0 2.5rem;
        background: #f9f9f9;
    }

    .btn {
        background-color: #5b7c8a;
        transition: all 0.5s ease;
        color: #ffffff;
    }

    .btn:hover {
        color: #ffffff;
    }

    .books-div,
    .chapters-div,
    .verses-div,
    .verses-history-div {
        height: 90vh;
        overflow-y: auto;
    }

    #bible-component .selection {
        margin: 0;
        padding: 10px 0 10px 15px;
    }

    #bible-component .selection a.btn {
        margin-right: 10px;
    }

    #bible-component .selection #bookSelection,
    #bible-component .selection #chapterSelection {
        max-width: 400px;
        width: 100%;
        padding: 0 10px;
    }

    #bible-component .selection #versionSelection {
        padding: 10px 5px;
        max-width: 160px;
        width: 100%;
    }

    #bible-component .selection #bookSelection li,
    #bible-component .selection #chapterSelection li,
    #bible-component .selection #versionSelection li  {
        text-align: center;
        /* padding: 10px 5px 10px 15px; */
        display: inline-block;
        width: 50px;
        line-height: 30px;
        font-weight: 300;
        font-size: 14px;
        min-height: 30px;
    }

    

    #bible-component li.collection-item {
        min-height: auto;
        font-size: 1.25rem;
        font-family: 'NewhouseDTPro-Light';
        cursor: pointer;
    }

    #bible-component li.collection-item:hover {
        background: #96acb626;
    }

    #bible-component li.collection-item .circle {
        border-radius: 0 !important;
        font-family: 'NewhouseDTCond-ExtBold';
        position: absolute;
        width: 42px;
        height: 42px;
        overflow: hidden;
        left: 15px;
        display: inline-block;
        vertical-align: middle;
        font-size: 1.25rem;
    }

    #bible-component li.collection-item.focused,
    #bible-component .selection #bookSelection li.active,
    #bible-component .selection #chapterSelection li.active,
    #bible-component .selection #versionSelection li.active {
        background: #5b7c8a26;
    }

    .testament {
        display: block !important;
        width: 100% !important;
        text-align: left !important;
        /* text-transform: uppercase; */
        font-weight: bold;
        border-bottom: 1px solid #ddd;
        margin: 5px 0;
        font-weight: bold;
        /* padding-left: 10px;*/
        cursor:default;
        background: transparent !important;
    }

    .historyBtn.active {
        background: #5b7c8a26;
    }
</style>
